export default{
  eventoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  boardColumnId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  data: {
    value: null,
    required: true,
    state: null
  },
  horario: {
    value: null,
    required: false,
    state: null,
    placeholder: 'Selecione',
    size: 'sm'
  },
  detalhes: {
    value: '',
    maxlength: '280',
    rows: 3,
    required: true,
    state: null,
    noResize: true
  },
  kmInicial: {
    value: null,
    required: false,
    state: null
  },
  kmFinal: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/followup/followup-form.js